import { Box, Chip, Stack, Typography } from '@mui/material';
import { FormFieldLabel } from 'src/components/Forms/FormFieldLabel/form-field-label';
import { SelectMenu, type SelectMenuOption } from 'src/components/SelectMenu';
import { mutedSx } from './styles';

interface CgCustomDomainSegmentsProps {
  brandIds: string[];
  options: SelectMenuOption[];
  onChange: (brandIds: string[]) => void;
}

export const CgCustomDomainSegments = ({
  brandIds,
  options,
  onChange,
}: CgCustomDomainSegmentsProps) => (
  <Box>
    <FormFieldLabel component="span">Client segments</FormFieldLabel>
    <SelectMenu
      multiple
      options={options}
      values={brandIds}
      onValuesChange={onChange}
      placeholder="Choose the client segments served here"
      menuWidth="trigger"
      sx={{ width: '100%' }}
    />

    {brandIds.length ? (
      <Stack direction="row" flexWrap="wrap" gap={1} sx={{ mt: 1.5 }}>
        {brandIds.map((brandId) => (
          <Chip
            key={brandId}
            size="small"
            label={options.find(({ value }) => value === brandId)?.title ?? brandId}
            onDelete={() => onChange(brandIds.filter((id) => id !== brandId))}
          />
        ))}
      </Stack>
    ) : (
      <Typography variant="body2" sx={{ ...mutedSx, mt: 1.5 }}>
        No client segments yet. Clients only reach this address once you add one.
      </Typography>
    )}
  </Box>
);
